<template lang="pug">
  v-dialog.grey(v-model="dialog" scrollable dark max-width="1100")
    template(v-slot:activator="{ on }")
      v-btn(color="primary" @click="openDialog" text v-on="on")
        v-tooltip(top)
          template(v-slot:activator="{ on, attrs }")
            v-icon(v-bind="attrs" v-on="on") mdi-repeat
          span Reproducción
    v-card
      v-card-title.d-flex.flex-nowrap.justify-space-between.headline.text-center(primary-title)
        span Reproducción
        v-btn(@click="dialog = false" icon)
          v-icon mdi-close
      div.d-flex.justify-center.py-12(v-if="loading")
        v-progress-circular(:size="50" color="primary" indeterminate)
      v-card-text.fantasy__scrollbar.px-2.px-sm-6.white--text(v-else)
        vue-json-pretty(v-if="action == 'json'" :path="'res'" :data="info.result.value")
        vue-json-pretty(v-else-if="action == 'txt'" :path="'res'" :data="info.result.value")
        iframe(v-else-if="action == 'url'"
          title="Iframe"
          width="100%"
          height="600"
          :src="info.result.value")
        v-img(v-else-if="action == 'image'" :src="info.result.value")
        p(v-else) error
</template>

<script>
import VueJsonPretty from 'vue-json-pretty'

export default {
  name: "LaunchDialog",
  components: {
    VueJsonPretty
  },
  props:{
    info: {
      type: Object,
      default: function(){
        return {}
      }
    },
    roundId: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data:() => ({
    dialog: false,
  }),
  computed: {
    action() {
      if (this.info.error == '0') {
        return this.info.result.type
      }
      return 'error'
    },
  },
  methods: {
    openDialog() {
      this.$emit('emitLaunch', this.roundId)
      this.dialog = true
    }
  }
}
</script>

<style lang="sass">
</style>